import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20luxurious%20abstract%20background%20with%20flowing%20gold%20ribbons%20and%20soft%20ambient%20glow%20elegant%20sophisticated%20cinematic%20atmosphere%20warm%20gold%20accents%20on%20deep%20charcoal%20black%20velvet%20texture%20artistic%20minimalist%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="欧美无码平台推荐指南"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
          <span className="text-xs text-primary-400 font-medium">2026年最新欧美无码平台评测</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight max-w-4xl mx-auto">
          欧美无码正版内容平台
          <span className="block text-primary-500">专业推荐指南</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          为成年用户提供最全面的欧美无码平台评测、高清资源推荐与安全观看指南。
          汇聚8大正版平台深度评测，助您快速找到最适合的内容平台。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/hd"
            className="px-8 py-3.5 bg-primary-500 text-background-950 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            查看平台评测
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/article/ultimate-review-2026"
            className="px-8 py-3.5 border border-foreground-300/30 text-foreground-800 font-semibold rounded-lg hover:bg-foreground-50/10 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            阅读终极评测
            <i className="ri-file-text-line ml-2"></i>
          </Link>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-foreground-500 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-primary-500 text-lg"></i>
            <span>正版认证平台</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-star-line text-primary-500 text-lg"></i>
            <span>客观公正评测</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-lock-line text-primary-500 text-lg"></i>
            <span>隐私安全指南</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-global-line text-primary-500 text-lg"></i>
            <span>全球平台覆盖</span>
          </div>
        </div>
      </div>
    </section>
  );
}